import PartnershipsHero from "./components/PartnershipsHero";
import PartnershipsOverview from "./components/PartnershipsOverview";
import WhoWePartnerWith from "./components/WhoWePartnerWith";
import PartnershipOpportunities from "./components/PartnershipOpportunities";
import WhyPartnerWithHarambee from "./components/WhyPartnerWithHarambee";
import PartnershipProcess from "./components/PartnershipProcess";
import PartnershipOutcomes from "./components/PartnershipOutcomes";
import CollaborationThemes from "./components/CollaborationThemes";
import PartnershipsFAQ from "./components/PartnershipsFAQ";
import PartnershipInquiryForm from "./components/PartnershipInquiryForm";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function PartnershipsPage() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Navbar />
      <main>
        <PartnershipsHero />
        <PartnershipsOverview />
        <WhoWePartnerWith />
        <PartnershipOpportunities />
        <WhyPartnerWithHarambee />
        <PartnershipProcess />
        <PartnershipOutcomes />
        <CollaborationThemes />
        <PartnershipsFAQ />
        <PartnershipInquiryForm />
      </main>
      <Footer />
    </div>
  );
}
